exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_sharePointManagementEditPanel_3R671wsH_hkmnISJMaBEwt {\n  position: relative;\n  width: 100%;\n  float: left;\n}\n\n.IA_sharePointManagementSearchResult_3Ji1T3LkqPkJa1FsQ7ialk {\n  padding: 10px 0;\n  clear: both;\n}", ""]);

// Exports
exports.locals = {
	"IA_sharePointManagementEditPanel": "IA_sharePointManagementEditPanel_3R671wsH_hkmnISJMaBEwt",
	"IA_sharePointManagementSearchResult": "IA_sharePointManagementSearchResult_3Ji1T3LkqPkJa1FsQ7ialk"
};